export interface PayoutsRouteParams {
  date: string;
  stateFilter?: string;
  payoutConfigFilter?: string;
}

export enum PayoutWebsitesSearchKey {
  SEARCH = 'search',
}

export enum PayoutConfigsSearchKey {
  SEARCH = 'search',
}
